exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".more\n{\n  color:#00C2C4;\n  font-size: 1em;\n  font-weight: bold;\n  float: left;\n  padding: 5px;\n}\n.less\n{\n  color:#00C2C4;\n  font-size: 1em;\n  font-weight: bold;\n  float: left;\n  padding: 5px;\n}\n.long-text-content\n{\n  transition: all 0.5s ease-in;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/shared/long-text/long-text.style.css
// module id = 970
// module chunks = 3